import { Base } from '@.api/methods';
import { AuthContextValue } from '@/Services/Auth';

import { NotificationsQuery, ReadNotificationsRequest, StationsQuery } from './request';
import { GetDeviceResponse, GetNotificationsBadgesResponse, GetStationResponse, NotificationsResponse, StationsResponse } from './response';

export class NotificationsApi extends Base {
    public constructor(auth?: AuthContextValue | null) {
        super(auth, 'v2');
    }

    public stations(query?: StationsQuery) {
        this.setPath('monitoring-stations');
        query && this.setQuery(query);

        return this.getRequest<StationsResponse>();
    }

    public getStation(stationId: number) {
        this.setPath(`monitoring-stations/${stationId}`);

        return this.getRequest<GetStationResponse>();
    }

    public getDevice(stationId: number, deviceId: number) {
        this.setPath(`monitoring-stations/${stationId}/devices/${deviceId}`);

        return this.getRequest<GetDeviceResponse>();
    }

    public getNotifications(query?: NotificationsQuery) {
        this.setPath('notifications');
        query && this.setQuery(query);

        return this.getRequest<NotificationsResponse>();
    }

    public readNotifications(request: ReadNotificationsRequest) {
        this.setPath('notification-readings');

        this.setData(request);

        return this.postRequest();
    }

    public getNotificationsBadges() {
        this.setPath('notification-badges');

        return this.getRequest<GetNotificationsBadgesResponse>();
    }
}
